import axios from 'axios';

import {
    HANDLE_OPT_IN,
    LOAD_BOOTSTRAP_DATA,
    LOAD_REPLIES_DATA,
    VITE_JIT_LOGIN_URL,
    VITE_REQUEST_OTP_URL,
    VITE_VERIFY_OTP_URL,
    VITE_VERIFY_DOB_URL,
    GET_STATUS_INFO,
    INITIAL_ACCESS_TOKEN,
    GET_IVR_MAP,
    GET_PROVIDER_LIST_URL,
} from 'constants/env.js';
import { addParamsToUrl, deleteCookie, setCookie } from 'utils/common/common';

const { VITE_CLIENT_ID, VITE_CLIENT_PASSWORD } = import.meta.env;
export const fetchJitAccessTokenAPI = async () => {
    const response = await axios.post(VITE_JIT_LOGIN_URL, {
        is_guest: true,
        partner_id: 9,
    });
    return response.data || {};
};

export const fetchJitAccessTokenAPINew = async ({ partnerId }) => {
    const x = axios
        .get('https://clarus-configs.s3.amazonaws.com/clarus-wma/sample.json')
        .then(response => response.data);
    return axios.post(VITE_JIT_LOGIN_URL, {
        is_guest: true,
        partner_id: partnerId,
    });
};

export const getInitailAccessToken = async () => {
    return axios.post(
        INITIAL_ACCESS_TOKEN,
        { grant_type: 'client_credentials', scope: 'wma' },
        {
            headers: {
                Authorization: `Basic ${btoa(`${VITE_CLIENT_ID}:${VITE_CLIENT_PASSWORD}`)}`,
                'Content-Type': 'application/json',
            },
        }
    );
};

export const getPartnerAPI = async ({ access_token, partnerId, requestId }) => {
    return axios.get(
        addParamsToUrl(LOAD_BOOTSTRAP_DATA, {
            partner_short_id: partnerId,
            request_id: requestId,
        }),
        {
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
        }
    );
};

export const requestOTPAPI = async ({
    phoneNumber,
    isRefresh,
    access_token,
    partnerId,
    requestId,
    resendInterval = 30, // default 30 seconds
}) => {
    const response = await axios.post(
        VITE_REQUEST_OTP_URL,
        {
            type: 'wma-otp',
            action: isRefresh ? 'refresh' : 'new',
            phone_number: phoneNumber,
        },
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // bootstrap access token
            },
        }
    );
    if (requestId) {
        deleteCookie(`otp-sent-${requestId}`);
        setCookie(`otp-sent-${requestId}`, true);
    }
    return response.data || {};
};

export const verifyOTPAPI = async ({ otp, phone_number, access_token }) => {
    const response = await axios.post(
        VITE_VERIFY_OTP_URL,
        {
            otp,
            phone_number,
        },
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // bootstrap access token
            },
        }
    );
    return response.data || {};
};

export const handleOptInStatus = async ({
    phone_number,
    access_token,
    partnerId,
}) => {
    let ip_address;
    await axios
        .get('https://api.ipify.org?format=json')
        .then(response => {
            ip_address = response?.data?.ip;
        })
        .catch(() => console.error('Error fetching IP address.'));

    const response = await axios.post(
        HANDLE_OPT_IN,
        {
            phone_number,
            campaigns: [
                {
                    campaign: 'wma',
                    pid: partnerId,
                    opt_in_status: 'true',
                    consent_medium: 'wma',
                    ip_address,
                },
            ],
        },
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // bootstrap access token
            },
        }
    );
    return response.data || {};
};

export const verifyDOBAPI = async ({ date_of_birth, access_token, callId }) => {
    const response = await axios.post(
        VITE_VERIFY_DOB_URL.replace('{callId}', callId),
        {
            date_of_birth,
        },
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // bootstrap access token
            },
        }
    );
    return response.data || {};
};

export const fetchRepliesData = async (callId, access_token) => {
    const response = await axios.get(
        LOAD_REPLIES_DATA.replace('{callId}', callId),
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // dob access token
            },
        }
    );
    return response.data || {};
};

export const fetchStatusInfo = async (requestId, access_token) => {
    const response = await axios.get(
        GET_STATUS_INFO.replace('{request_id}', requestId),
        {
            headers: {
                Authorization: `Bearer ${access_token}`, // bootstrap access token
            },
        }
    );
    return response?.data?.data || {};
};

export const fetchWMAMap = async ({ partnerId, access_token }) => {
    const response = await axios.get(
        GET_IVR_MAP.replace('{partnerId}', partnerId),
        {
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
        }
    );
    return response?.data?.wma_map || {};
};

export const getProviderList = async ({
    partnerId,
    access_token,
    page = 1,
    limit = 15,
}) => {
    const response = await axios.get(
        GET_PROVIDER_LIST_URL.replace('{partnerId}', partnerId),
        {
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
            params: { page, limit },
        }
    );
    return response.data || [];
};
